import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { CLRS } from "../constants/colors";
import { Box, Input, Label, Select, Option, Button, Heading } from "./elements";
import { Form, Col } from "react-bootstrap";
import { Breadcrumb } from "./index";
import { ref, uploadBytes, getDownloadURL, getStorage, deleteObject } from "firebase/storage";
import { toast } from "react-toastify";

export const Txt = (p) => {
  return (
    <label
      onClick={p.onClick ? p.onClick : null}
      style={{
        fontSize: p.s ? p.s : 14,
        color:
          p.c === "pr"
            ? CLRS.PRIMARY
            : p.c === "sc"
              ? CLRS.SECONDARY
              : p.c === "thrd"
                ? "#777"
                : p.c === "r"
                  ? CLRS.RED
                  : p.c === "w"
                    ? "#fff"
                    : p.c === "green"
                      ? CLRS.GREEN
                      : p.c
                        ? p.c
                        : "#000",
        marginBottom: p.mb ? p.mb : 0,
        marginTop: p.mt ? p.mt : 0,
        marginRight: p.mr ? p.mr : 0,
        marginLeft: p.ml ? p.ml : 0,
        textAlign: p.a === "l" ? "left" : p.a === "c" ? "center" : p.a === "r" ? "right" : "auto",
        flex: p.fl ? 1 : null,
        fontWeight: p.w ? p.w : "400",
        cursor: p.point ? "pointer" : "default",
        textDecoration: p.underline ? "underline" : "none",
        ...p.style,
      }}
    >
      {p.children}
    </label>
  );
};
export const GetIDFromPath = (location) => {
  let url = location.pathname;
  url = url.split("/");
  if (url && url.length > 1) {
    return url[2];
  } else {
    return false;
  }
};
export const GetIDFromState = (location) => {
  if (location && location.state && location.state.id) {
    return location.state.id;
  } else {
    return false;
  }
};

export const setMoneyFormat = (numb) => {
  if (Number(numb)) {
    numb = Number(numb);
    function separator(numb) {
      var str = numb.toString().split(".");
      str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return str.join(".");
    }
    // return ((store.getState().user.priceLabel?`${store.getState().user.priceLabel} `:"") + separator(numb)) ;
    return "₹ " + separator(numb);
  }
  return "₹ 0";
};

export const SuccessToast = (label, isUpdate) => {
  if (isUpdate) {
    toast(`${label} updated successfully`, { type: "success" });
  } else {
    toast(`${label} added successfully`, { type: "success" });
  }
};

export const DeleteToast = (label) => {
  toast(`${label} deleted successfully`, { type: "success" });
};

export const SomethingWentWrongToast = () => {
  toast("Something went wrong. Please try again", { type: "error" });
};

export const UnitsList = [
  { id: "Hour", name: "Hour" },
  { id: "Day", name: "Day" },
];
export const Btn = ({ onClick, loading, disabled, wi, style, ml, mb, mt, mr, title, primary, danger }) => {
  return (
    <button
      onClick={onClick}
      disabled={loading ? true : disabled}
      style={{
        width: wi ? wi : null,
        marginLeft: ml ? ml : 0,
        marginTop: mt ? mt : 0,
        marginBottom: mb ? mb : 0,
        marginRight: mr ? mr : 0,

        ...style,
      }}
      className={`btn btn-${danger ? "danger" : primary ? "primary" : "secondary"} btn-block`}
    >
      {loading ? "Loading..." : title}
    </button>
  );
};

export const CInput = (p) => {
  const inref = useRef();
  const t_focus = () => {
    inref.current.focus();
  };
  useEffect(() => {
    if (p.focus) {
      p.focus(() => {
        t_focus();
      });
    }
  }, []);

  return (
    <div
      className="form-group mg-b-0"
      style={{
        flex: p.fl ? 1 : null,
        marginTop: p.mt ? p.mt : 0,
        marginLeft: p.ml ? p.ml : 0,
        marginRight: p.mr ? p.mr : 0,
        marginBottom: p.mb ? p.mb : 0,
        display: "flex",
        flexDirection: "column",
        ...p.style,
      }}
    >
      {/* <p style={{textAlign:"left",fontSize:14}} className="mg-b-5">{p.title}</p> */}
      <Label style={{ textAlign: "left" }} className="mc-label-field-title mb-2">
        {p.title}
      </Label>
      <Input
        value={p.value}
        className={`mc-label-field-input ${p.fieldSize || "w-md h-sm"}`}
        disabled={p.dis}
        dir={p.rtl ? "rtl" : ""}
        type={p.date ? "date" : p.number ? "number" : p.date ? "date" : p.password ? "password" : p.file ? "file" : "text"}
        maxLength={p.length}
        ref={inref}
        onChange={(e) => {
          let text = e.target.value;
          p.onChange(text);
        }}
        placeholder={p.placeholder}
        style={{
          border: p.err ? "red 1px solid" : "",
          width: p.fill ? "100%" : "auto",
        }}
        list={p.list}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (p.onEnterPress) {
              p.onEnterPress();
            }
          }
        }}
        {...p.inputProps}
      />
      {p.hide_error ? null : p.show_err_height && !p.err ? (
        <div style={{ height: 18 }} />
      ) : (
        <Txt style={{ width: "100%" }} s={12} a="l" c={p.err ? "r" : ""}>
          {p.err ? p.err : p.subText}
        </Txt>
      )}
    </div>
  );
};
export const CheckSuccessAPI = (status, response) => {
  if (status && response && response.status === "Success") {
    return true;
  }
  return false;
};

export const CSwitch = ({ label, defaultChecked = false, onChange, value, style }) => {
  return (
    <Form.Check
      style={style}
      type="switch"
      id="switch2"
      value={value}
      onChange={onChange}
      label={label}
      defaultChecked={defaultChecked}
    />
  );
};

export const LabelData = ({ data, label, style, mt, mb, ml, mr, fl, click_sub, onClick_Sub, valueColor, color }) => {
  return (
    <div
      style={{
        flex: fl ? 1 : null,
        marginTop: mt ? mt : 0,
        marginLeft: ml ? ml : 0,
        marginRight: mr ? mr : 0,
        marginBottom: mb ? mb : 0,
        ...style,
      }}
    >
      <label style={{ color: "#777", fontSize: 12 }}>{label}</label>
      <br />
      <label
        style={{
          fontSize: 14,
          fontWeight: 500,
          color: valueColor ?? CLRS.MATTBLACK,
        }}
      >
        {String(data) ? data : "-"}
      </label>
      {click_sub ? (
        <label onClick={onClick_Sub} className="point" style={{ fontSize: 12, marginLeft: 8, color: color }}>
          {click_sub}
        </label>
      ) : null}
    </div>
  );
};

export const LabelDataBold = ({ mt, ml, mr, mb, fl, style, label, data, money }) => {
  return (
    <div
      style={{
        flex: fl ? 1 : null,
        marginTop: mt ? mt : 0,
        marginLeft: ml ? ml : 0,
        marginRight: mr ? mr : 0,
        marginBottom: mb ? mb : 0,
        ...style,
      }}
    >
      <p className="mg-b-5" style={{ marginBottom: 10 }}>
        {label}
      </p>
      <label style={{ fontSize: 14, fontWeight: 500, color: CLRS.MATTBLACK }}>
        {money ? setNumberFormat(data) : String(data) ? data : "-"}
      </label>
    </div>
  );
};

export const Picker = (p) => {
  return (
    <Box
      className={`mc-label-field-group ${p.title ? p.labelDir || "label-col" : ""}`}
      style={{
        flex: p.fl ? 1 : null,
        marginTop: p.mt ? p.mt : 0,
        marginLeft: p.ml ? p.ml : 0,
        marginRight: p.mr ? p.mr : 0,
        marginBottom: p.mb ? p.mb : 0,
        ...p.style,
      }}
    >
      {p.title && <Label className="mc-label-field-title">{p.title}</Label>}
      <Select
        className={`mc-label-field-select ${p.fieldSize || "w-md h-sm"}`}
        value={p.value}
        onChange={(e) => {
          p.onSelect(e.target.value);
        }}
        style={{ width: "100%", ...p.selectStyle, marginTop: 8 }}
      >
        {p.add_all ? <Option>All</Option> : null}
        {p.add_select ? <Option>Select</Option> : null}
        {p.list.map((it) => {
          if (p.field) {
            return <Option value={it[p.value_field]}>{it[p.field]}</Option>;
          } else {
            return <Option>{it}</Option>;
          }
        })}
      </Select>
      {p.hide_error ? null : (
        <Txt s={12} c="r">
          {p.err}
        </Txt>
      )}
    </Box>
  );
};

export const HAND_ACCOUNT = {
  name: "CASH",
  id: "hand",
};

export const Loading = () => {
  // return(
  //     <View style={{flex:1,alignItems:'center',justifyContent:'center',height:windowHeight}}>
  //         <ActivityIndicator style={{marginBottom:60}} size={"large"} color={CLRS.PRIMARY} />
  //     </View>
  // )
};

export const get_profile_name = (name) => {
  if (!name) return "";
  var parts = name.split(" ");
  var result = parts
    .map(function (p) {
      return p.charAt(0).toLocaleUpperCase();
    })
    .join("");
  return result.substring(0, 2);
};

export const get_error_string = (str, label, min) => {
  if (str) {
    if (str === "") {
      return `${label} required`;
    } else {
      if (str.length < min) {
        return `${label} should be minimum ${min} character`;
      } else {
        return false;
      }
    }
  } else {
    return `${label} required`;
  }
};

export const CheckBox = (p) => {
  return (
    <div
      style={{
        flex: p.fl ? 1 : null,
        marginTop: p.mt ? p.mt : 0,
        marginLeft: p.ml ? p.ml : 0,
        marginRight: p.mr ? p.mr : 0,
        marginBottom: p.mb ? p.mb : 0,
        ...p.style,
      }}
    >
      <label class="ckbox">
        <input onChange={p.onChange} checked={p.value ? true : false} type="checkbox" />
        <span>{p.title}</span>
      </label>
    </div>
  );
};

export const get_date = (date, format) => {
  if (format) {
    return moment(date).format(format);
  } else {
    return moment(date).format("DD MMM YYYY");
  }
};

export const Tost_Massages = {
  No_net: "You are not connected to the internet",
  wrong: "Something went wrong please try again later",
  trans_error: "Transaction failed, please try again",
  no_data_found: "No Data Found",
};

export const setNumberFormat = (numb) => {
  if (Number(numb)) {
    numb = Number(numb);
    function separator(numb) {
      var str = numb.toString().split(".");
      str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return str.join(".");
    }
    return "₹ " + separator(numb);
  }
  return "₹ 0";
};

export const CardTitle = ({ title, fl, mt, ml, mr, mb, style, addBtn, onAddClick }) => {
  return (
    <div
      className="fl-justify-center "
      style={{
        flex: fl ? 1 : null,
        marginTop: mt ? mt : 0,
        marginLeft: ml ? ml : 0,
        marginRight: mr ? mr : 0,
        marginBottom: mb ? mb : 0,
        ...style,
      }}
    >
      <h4 class="card-title mg-b-2 mt-2 fl-1" style={{ flex: 1 }}>
        {title}
      </h4>
      {addBtn ? (
        <label className="point viewAllLabel" onClick={onAddClick}>
          {addBtn}
        </label>
      ) : null}
    </div>
  );
};
export const CheckPositiveNumberReturnZero = (value) => {
  if (value && Number(value) && Number(value) > 0) {
    return Number(value);
  }
  return 0;
};

export const Check_Positive_Number_Error = (value, name) => {
  if (value && Number(value) && Number(value) > 0) {
    return false;
  }
  if (name) {
    if (value) {
      return `${name} should be a positive number`;
    }
    return `${name} required`;
  }
  if (value) {
    return "Value should be a positive number";
  }
  return `Value required`;
};
export const Check_OBJ_Required_Error = (obj, feild, name) => {
  if (obj && obj[feild]) {
    if (obj[feild] === "Select") {
      return `${name} required`;
    }
    return false;
  }
  if (name) {
    return `${name} required`;
  }
  return "Value required";
};

export const Edit_Delete_Btns = ({ onEditPress, onDeletePress, style }) => {
  return (
    <div style={style}>
      {onEditPress ? (
        <i
          className="side-menu__icon fe fe-edit point "
          onClick={onEditPress}
          style={{ color: "#000", marginLeft: 8, fontSize: 16 }}
        ></i>
      ) : null}
      {onDeletePress ? (
        <i
          className="side-menu__icon fe fe-trash point "
          onClick={onDeletePress}
          style={{ color: "#000", marginLeft: 8, fontSize: 16 }}
        ></i>
      ) : null}
    </div>
  );
};

export const RadioBtn = ({ onClick, active = false, title = "", style = {} }) => {
  return (
    <div onClick={onClick} className="fl" style={{ alignItems: "center", ...style }}>
      <div
        style={{
          width: 16,
          height: 16,
          borderRadius: 200,
          border: active ? "5px blue solid" : "2px #aaa solid",
        }}
      />
      <Txt ml={6}>{title}</Txt>
    </div>
  );
};

export const RadioBtnCollection = ({ title, list = [], onSelect, value, style, radioContainer }) => {
  return (
    <div className="fl" style={style}>
      <Label style={{ textAlign: "left" }} className="mc-label-field-title">
        {title}
      </Label>
      <div className="fl" style={radioContainer}>
        {list.map((it) => {
          return (
            <RadioBtn
              key={it.value}
              onClick={() => onSelect(it)}
              style={{ marginLeft: 8 }}
              title={it.title}
              active={value === it.value}
            />
          );
        })}
      </div>
    </div>
  );
};

export const ReportDownloadComponent = () => {
  return (
    <div className="fl" style={{ marginLeft: 20, marginTop: 16 }}>
      <Txt c="blue" style={{ textDecoration: "underline" }}>
        Print
      </Txt>
      <Txt c="blue" style={{ textDecoration: "underline" }} ml={8}>
        Export
      </Txt>
    </div>
  );
};

export const GetItemID = (item) => {
  return item && item.id && item.id !== "Select" ? item.id : 0;
};

export const setSearchPickerDefaulValue = (value) => {
  if (value && value.id) {
    return {
      id: value.id,
      name: value.name,
      label: value.name,
      value: value.id,
    };
  }
  return {};
};

export const getDefaultLocationParams = (props) => {
  if (props && props.location && props.location.state) {
    return {
      comeBack: props.location.state.comeBack ? true : false,
    };
  }
  return {
    comeBack: false,
  };
};

export const UnderLineText = (props) => {
  return (
    <Txt
      onClick={props.onClick}
      {...props}
      style={{
        color: "#0000AA",
        fontSize: 12,
        textDecoration: "underline",
      }}
      point
    >
      {props.value}
    </Txt>
  );
};

export const Get_Status_Varient = (status) => {
  const statusList = {
    Pending: "purple",
    Packing: "blue",
    Ready: "yellow",
    Picked: "orange",
    Delivered: "green",
    Cancelled: "red",
  };
  return statusList[status];
};
export const Get_Revervation_Status_Class = (status) => {
  const statusList = {
    pending: "purple",
    confirmed: "blue",
    completed: "green",
    cancelled: "red",
  };
  return statusList[status];
};

export const AddNewButton = ({ label = "+ Add New", props, onClick }) => {
  return (
    <Txt c={CLRS.NEWBLUE} w="700" style={{ cursor: "pointer" }} {...props} onClick={onClick}>
      {label}
    </Txt>
  );
};

export const UploadImageToFirebaseStorage = async (image, folder, name) => {
  const storage = getStorage();
  const storageRef = ref(storage, `${folder}/${name}`);
  try {
    const uploaded = await uploadBytes(storageRef, image, {
      contentType: image.type,
    });
    if (uploaded) {
      return getDownloadURL(storageRef);
    } else {
      return false;
    }
  } catch (error) {
    console.log("error: ", error);
    return false;
  }
};

export const formValidationRules = (label) => {
  return {
    String100Req: {
      required: { value: true, message: `${label} Required` },
      maxLength: {
        value: 100,
        message: `${label} length should be less than 100`,
      },
    },
    String100: {
      maxLength: {
        value: 100,
        message: `${label} length should be less than 100`,
      },
    },
    String20Req: {
      required: { value: true, message: `${label} Required` },
      maxLength: {
        value: 20,
        message: `${label} length should be less than 20`,
      },
    },
    String20: {
      maxLength: {
        value: 20,
        message: `${label} length should be less than 20`,
      },
    },

    String500Req: {
      required: { value: true, message: `${label} Required` },
      maxLength: {
        value: 500,
        message: `${label} length should be less than 500`,
      },
    },
    String500: {
      maxLength: {
        value: 500,
        message: `${label} length should be less than 500`,
      },
    },
    String1000: {
      maxLength: {
        value: 1000,
        message: `${label} length should be less than 1000`,
      },
    },
    pickerReq: {
      required: { value: true, message: `${label} Required` },
    },
    positiveNumberReq: {
      required: { value: true, message: `${label} Required` },
      pattern: { value: /^[0-9]+\.?[0-9]*/, message: `Invalid ${label}` },
    },
    positiveNumber: {
      pattern: { value: /^[0-9]+\.?[0-9]*/, message: `Invalid ${label}` },
    },
    shouldNumberReq: {
      required: { value: true, message: `${label} Required` },
      pattern: { value: /^[0-9]+\.?[0-9]*/, message: `Invalid ${label}` },
    },
    shouldNumber: {
      pattern: { value: /^[0-9]*/, message: `Invalid ${label}` },
    },
    mobileNumber: {
      pattern: {
        value: /^[0-9]{10}$/,
        message: "Enter a valid 10-digit mobile number",
      },
    },
    mobileNumberReq: {
      required: { value: true, message: `${label} Required` },
      pattern: {
        value: /^[0-9]{10}$/,
        message: "Enter a valid 10-digit mobile number",
      },
    },
    date: {
      pattern: {
        value: /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/,
        message: `Invalid ${label}`,
      },
    },
    dateReq: {
      required: { value: true, message: `${label} Required` },
      pattern: {
        value: /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/,
        message: `Invalid ${label}`,
      },
    },
    fileReq: {
      required: { value: true, message: `${label} Required` },
      validate: {
        validateFileUpload: (file) => {
          if (!file[0]) {
            return "Please select a file.";
          }

          const allowedFileTypes = ["jpg", "jpeg", "png", "gif", "pdf"];
          const allowedFileSizeInBytes = 5242880; // 5MB

          const fileName = file[0].name;
          const fileExtension = fileName.split(".").pop().toLowerCase();
          const fileSize = file[0].size;

          if (!allowedFileTypes.includes(fileExtension)) {
            return "Invalid file type. Allowed types are: pdf, jpg, jpeg, png, gif.";
          }

          if (fileSize > allowedFileSizeInBytes) {
            return "File size exceeds the allowed limit (5MB).";
          }

          return true; // The file is valid
        },
      },
    },
  };
};

export const AppBreadcrumb = ({ title, rightButtom, onRightButtonClick }) => {
  return (
    <Col xl={12}>
      <Box className="mc-card">
        <Breadcrumb title={title}>
          {rightButtom ? (
            <Button onClick={onRightButtonClick} icon="add" className="mc-btn gray sm m-2" label="asdasd">
              {rightButtom}
            </Button>
          ) : null}
        </Breadcrumb>
      </Box>
    </Col>
  );
};

export const AppHeading = ({ title, icon, onAddClick, onEditClick, onDeleteClick }) => {
  if (icon) {
    return (
      <div className="fl" style={{ alignItems: "center", justifyContent: "space-between" }}>
        <div className="fl" style={{ alignItems: "center" }}>
          <div className="header-icon-container">
            <i style={{ color: "#2351af" }} className={"material-icons"}>
              {icon}
            </i>
          </div>
          <Heading as="h4" style={{ marginLeft: 8, color: "#2351af" }} className="mc-card-title">
            {title}
          </Heading>
        </div>

        {onAddClick && (
          <Box className="mc-table-action">
            <Button title="Add" className="material-icons edit" onClick={onAddClick}>
              add
            </Button>
          </Box>
        )}

        {onEditClick && (
          <Box className="mc-table-action">
            <Button title="Edit" className="material-icons edit" onClick={onEditClick}>
              edit
            </Button>
          </Box>
        )}
      </div>
    );
  }
  return (
    <div className="fl" style={{ alignItems: "center", justifyContent: "space-between" }}>
      <Heading as="h4" style={{ color: "#2351af" }} className="mc-card-title">
        {title}
      </Heading>

      <Box className="mc-table-action">
        {onEditClick && (
          <Button title="Edit" className="material-icons edit" onClick={onEditClick}>
            edit
          </Button>
        )}

        {onDeleteClick && (
          <Box className="mc-table-action">
            <Button title="Delete" className="material-icons delete" onClick={onDeleteClick}>
              delete
            </Button>
          </Box>
        )}
      </Box>
    </div>
  );
};

export const VerticalSpace = ({ height }) => {
  return <div style={{ height }} />;
};

export const HorizontalSpace = ({ width }) => {
  return <div style={{ width }} />;
};
